import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta'
Vue.config.productionTip = false
import '@/assets/scss/functions.scss'
  // 在main.js中全局注册
  // import screenWidthMixin from './mixins/screenWidthMixin'
  // Vue.mixin(screenWidthMixin)
  import '@/assets/style/global.css'
import 'animate.css';
import AOS from 'aos';
import 'aos/dist/aos.css'; // 引入样式

// 初始化 AOS
AOS.init({
  duration: 800,      // 动画时长（ms）
  easing: 'ease-in-out', // 缓动函数
  once: false,        // 是否只执行一次
  offset: 100,        // 触发偏移量（px）
  delay: 100,         // 延迟（ms）
});
// import myFooter from '@/components/footer.vue'
// import myHeader from '@/components/header.vue'

// Vue.component('my-footer', myFooter)
// Vue.component('my-header', myHeader)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: false
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app') 